import { UI_TABLE_DEFAULT_PAGE_SIZE } from "../../../../../utils/tablePageSize";
import { eventTypes } from "../../../../../utils/Constants";

export const PAYROLL_PAYMENT_PERIODS = eventTypes;

export const PAYROLL_PAYMENT_STATUSES = {
  pending: "unpaid",
  paid: "paid",
};

export const PAYROLL_REMOVED_STATUSES = {
  removed: "removed",
  assigned: "assigned",
};

export const PAYROLL_REWARD_TYPES = {
  reward: "reward",
  dedication: "dedication",
};

export const PAYROLL_ADJUSTMENT_TYPES = {
  reward: "reward",
  deduction: "deduction",
};

export const PAYROLL_ADJUSTMENT_API_TYPES = {
  reward: "reward",
  deduction: "manual_deduction",
};

export const PAYROLL_REASON_TYPE_FILTERS = {
  reward: "reward,neutral",
  deduction: "deduction,neutral",
};

export const PAYROLL_ADJUSTMENT_LIST_TYPE_FILTERS = {
  reward: "reward",
  deduction: "manual_deduction,automatic_deduction",
};

export const PAYROLL_ADJUSTMENT_STATUSES = {
  active: "active",
  reverted: "reverted",
  cancelled: "cancelled",
};

export const PAYROLL_EMPTY_STATE_VARIANTS = {
  event: "event",
  filtered: "filtered",
};

export const PAYROLL_DEFAULT_PAGE_SIZE = UI_TABLE_DEFAULT_PAGE_SIZE;

export const isMonthlyPayrollEvent = (event) =>
  event?.payment_period === PAYROLL_PAYMENT_PERIODS.monthly;

export const isDailyPayrollEvent = (event) =>
  event?.payment_period === PAYROLL_PAYMENT_PERIODS.daily ||
  !event?.payment_period;
